import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { ToPayContainer } from './ToPayContainer';

export default class Home extends PureComponent {
  static propTypes = {
    toPay: PropTypes.number,
    accrualIsPresent: PropTypes.bool,
    hasDebts: PropTypes.bool,
  };

  getContent() {
    const { hasDebts, accrualIsPresent } = this.props;

    return (
      <div className="content">
        <ToPayContainer hasDebts={hasDebts} accrualIsPresent={accrualIsPresent} />
        {/* <MenuContainer isHomepage={true} hasWrapper={false} /> */}
      </div>
    );
  }

  render() {
    return (
      <div className="main-page_center">
        <div className="main-page_cell">{this.getContent()}</div>
      </div>
    );
  }
}
